import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { aboutInfo } from '@/mocks/forum';
import { get_form_url } from '@/mocks/formUrl';

function AboutSchema() {
  const origin = window.location.origin + __BASE_PATH__;
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '爱情岛论坛',
        url: origin,
        description: '爱情岛论坛成立于2018年，是一个专注于情感交流与恋爱话题的中文社区平台。',
        foundingDate: '2018-03',
        slogan: '让每一份情感都被温柔以待',
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: aboutInfo.contact.phone,
          contactType: 'customer service',
          email: aboutInfo.contact.email,
        },
        address: {
          '@type': 'PostalAddress',
          streetAddress: aboutInfo.contact.address,
          addressLocality: '杭州',
          addressRegion: '浙江',
          addressCountry: 'CN',
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.8',
          reviewCount: '12580',
        },
      },
      {
        '@type': 'WebPage',
        name: '关于我们 - 爱情岛论坛',
        url: `${origin}/about`,
        description: '了解爱情岛论坛的品牌故事、发展历程、用户口碑和联系方式。',
        isPartOf: { '@type': 'WebSite', name: '爱情岛论坛' },
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: origin },
          { '@type': 'ListItem', position: 2, name: '关于我们', item: `${origin}/about` },
        ],
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '爱情岛论坛是什么？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '爱情岛论坛是一个专注于情感交流与恋爱话题的中文社区平台，致力于为用户提供温暖、真诚、开放的交流空间。',
            },
          },
          {
            '@type': 'Question',
            name: '如何注册爱情岛论坛？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '您可以点击页面右上角的"注册"按钮，填写基本信息即可完成注册，成为我们社区的一员。',
            },
          },
          {
            '@type': 'Question',
            name: '爱情岛论坛有哪些功能？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '爱情岛论坛提供情感文章阅读、社区互动讨论、情感问答、线下交友活动、情感课程等多种功能，满足不同用户的需求。',
            },
          },
        ],
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

let contactSubmitAddr = '';

async function initFormUrl() {
  try {
    const result = await get_form_url('爱情岛论坛联系我们');
    contactSubmitAddr = result.submitAddr;
  } catch (e) {
    // fallback
  }
}
initFormUrl();

export default function About() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    initFormUrl();
  }, [location.pathname]);

  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypot && honeypot.value.trim()) {
      const successEl = form.querySelector('.form-success');
      if (successEl) (successEl as HTMLElement).classList.remove('hidden');
      return;
    }
    if (!contactSubmitAddr) {
      const errorEl = form.querySelector('.form-error');
      if (errorEl) {
        errorEl.textContent = '表单暂不可用，请稍后再试';
        errorEl.classList.remove('hidden');
      }
      return;
    }
    const formData = new FormData(form);
    formData.delete('website_alt');
    try {
      const res = await fetch(contactSubmitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* noop */ }
      if (res.ok && (parsed as { code?: string }).code === 'OK') {
        form.reset();
        const successEl = form.querySelector('.form-success');
        if (successEl) successEl.classList.remove('hidden');
        const errorEl = form.querySelector('.form-error');
        if (errorEl) errorEl.classList.add('hidden');
      } else {
        const msg = (parsed as { meta?: { message?: string } }).meta?.message
          || (parsed as { message?: string }).message
          || responseText
          || '提交失败，请稍后重试';
        const errorEl = form.querySelector('.form-error');
        if (errorEl) {
          errorEl.textContent = msg;
          errorEl.classList.remove('hidden');
        }
      }
    } catch {
      const errorEl = form.querySelector('.form-error');
      if (errorEl) {
        errorEl.textContent = '网络错误，请检查连接后重试';
        errorEl.classList.remove('hidden');
      }
    }
  };

  return (
    <>
      <AboutSchema />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <section className="relative w-full h-[340px] md:h-[440px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=warm%20abstract%20flowing%20gradient%20in%20soft%20rose%20and%20peach%20tones%20with%20delicate%20light%20particles%2C%20gentle%20dreamy%20watercolor%20texture%2C%20ethereal%20atmosphere%20with%20warm%20ambient%20glow&width=1800&height=900&seq=about-hero-bg&orientation=landscape"
            alt="关于爱情岛论坛"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/35 via-foreground-950/20 to-foreground-950/45"></div>
          <div className="relative z-10 text-center px-4 w-full">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-3">关于我们</h1>
            <p className="text-base md:text-lg text-background-200">了解爱情岛论坛的品牌故事与发展历程</p>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-4 md:px-6 py-10">
          <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
        </section>

        <section className="max-w-7xl mx-auto px-4 md:px-6 pb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
                {aboutInfo.brand.slogan}
              </h2>
              {aboutInfo.brand.description.split('\n\n').map((para, i) => (
                <p key={i} className="text-base text-foreground-700 leading-relaxed mb-4">{para}</p>
              ))}
            </div>
            <div className="grid grid-cols-2 gap-4">
              {aboutInfo.brand.values.map((val) => (
                <div key={val.title} className="bg-background-100 rounded-xl p-6 border border-background-200/70">
                  <h3 className="text-lg font-heading font-bold text-primary-600 mb-2">{val.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{val.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full bg-background-100 py-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">发展历程</h2>
            <p className="text-sm text-foreground-500 text-center mb-12">从2018年至今，爱情岛论坛走过的每一步</p>
            <div className="relative">
              <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-background-300/60 -translate-x-1/2"></div>
              <div className="flex flex-col gap-8">
                {aboutInfo.timeline.map((item, index) => (
                  <div key={item.year} className={`flex items-center ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                    <div className="hidden md:flex flex-1 justify-end px-8">
                      {index % 2 === 0 && (
                        <div className="bg-background-50 rounded-xl p-5 border border-background-200/70 max-w-sm">
                          <p className="text-sm text-foreground-700 leading-relaxed">{item.event}</p>
                        </div>
                      )}
                    </div>
                    <div className="flex-shrink-0 relative z-10 flex items-center justify-center">
                      <div className="w-12 h-12 rounded-full bg-primary-500 flex items-center justify-center">
                        <span className="text-xs font-bold text-background-50">{item.year}</span>
                      </div>
                    </div>
                    <div className={`flex-1 px-4 md:px-8 ${index % 2 === 0 ? 'block md:hidden' : ''}`}>
                      {index % 2 === 1 ? (
                        <div className="bg-background-50 rounded-xl p-5 border border-background-200/70 max-w-sm ml-auto md:ml-0">
                          <p className="text-sm text-foreground-700 leading-relaxed">{item.event}</p>
                        </div>
                      ) : (
                        <div className="md:hidden bg-background-50 rounded-xl p-5 border border-background-200/70">
                          <p className="text-sm text-foreground-700 leading-relaxed">{item.event}</p>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-4 md:px-6 py-16">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">用户口碑</h2>
          <p className="text-sm text-foreground-500 text-center mb-12">听听社区成员怎么说</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-14">
            {aboutInfo.reputation.testimonials.map((t) => (
              <div key={t.name} className="bg-background-100 rounded-xl p-6 border border-background-200/70">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-11 h-11 rounded-full overflow-hidden bg-background-200">
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">{t.content}</p>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
            {aboutInfo.reputation.stats.map((stat) => (
              <div key={stat.label} className="text-center p-6 bg-background-100 rounded-xl border border-background-200/70">
                <p className="text-3xl md:text-4xl font-heading font-bold text-primary-500">{stat.value}</p>
                <p className="text-sm text-foreground-500 mt-2">{stat.label}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="w-full bg-background-100 py-16">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">联系我们</h2>
            <p className="text-sm text-foreground-500 text-center mb-12">如果你有任何问题或建议，欢迎与我们取得联系</p>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              <div className="flex flex-col gap-6">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 flex-shrink-0">
                    <i className="ri-mail-line text-xl text-primary-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-950 mb-1">电子邮件</h4>
                    <p className="text-sm text-foreground-600">{aboutInfo.contact.email}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 flex-shrink-0">
                    <i className="ri-phone-line text-xl text-primary-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-950 mb-1">电话</h4>
                    <p className="text-sm text-foreground-600">{aboutInfo.contact.phone}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 flex-shrink-0">
                    <i className="ri-wechat-line text-xl text-primary-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-950 mb-1">微信</h4>
                    <p className="text-sm text-foreground-600">{aboutInfo.contact.wechat}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-primary-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-950 mb-1">公司地址</h4>
                    <p className="text-sm text-foreground-600">{aboutInfo.contact.address}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 flex-shrink-0">
                    <i className="ri-time-line text-xl text-primary-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-950 mb-1">工作时间</h4>
                    <p className="text-sm text-foreground-600">{aboutInfo.contact.workingHours}</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                <h3 className="text-lg font-heading font-bold text-foreground-950 mb-5">发送消息</h3>
                <form data-readdy-form="" onSubmit={handleContactSubmit}>
                  <div className="flex flex-col gap-4">
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                      <input id="contact-name" name="name" type="text" required className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-background-50 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors" placeholder="请输入您的姓名" />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                      <input id="contact-email" name="email" type="email" required className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-background-50 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors" placeholder="请输入您的邮箱" />
                    </div>
                    <div>
                      <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
                      <input id="contact-subject" name="subject" type="text" required className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-background-50 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors" placeholder="请输入消息主题" />
                    </div>
                    <div>
                      <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">消息内容</label>
                      <textarea id="contact-message" name="message" rows={4} maxLength={500} required className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-background-50 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors resize-none" placeholder="请输入您的消息（500字以内）"></textarea>
                      <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
                    </div>
                    <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="antispam-hide" />
                    <button type="submit" className="w-full px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap text-sm">
                      发送消息
                    </button>
                    <p className="form-success hidden text-sm text-accent-600 bg-accent-50 px-4 py-2 rounded-lg text-center">消息发送成功！我们会尽快回复您。</p>
                    <p className="form-error hidden text-sm text-red-600 bg-red-50 px-4 py-2 rounded-lg text-center"></p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}